import React, { useState, useEffect, useCallback } from "react";
import { BiSearch } from "react-icons/bi";
import Card from "./Card";
import { useSelector, useDispatch } from "react-redux";
import { fetchSupplierProductList, fetchSubCategories } from "../../../redux/actions/ProjectReportAction";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import RoundedPagination from "../../Paginate";
import { decodeBase64ToId } from "../../../util/generalUtills";

const SupplierProductCards = ({ page, setPage }) => {

  let { id } = useParams();
  const { subcategory, supplierProducts } = useSelector((state) => state.projectReportReducer);

  const [search, setSearch] = useState("");
  const [sector, setSector] = useState("");
  const [supplier, setSupplier] = useState(null);
  const [industry, setIndustry] = useState("");
  const [industries, setIndustries] = useState([]);
  const [paginate, setPaginate] = useState(10);

  const dispatch = useDispatch();
  const router = useNavigate();
  useEffect(() => {
    if (id) {
      setSupplier(decodeBase64ToId(id));
    }
  }, [id]);
  useEffect(() => {
    if (supplierProducts?.supplierProducts?.data?.length == 0) {
      setPage(0);
    }
  }, [supplierProducts]);
  useEffect(() => {
    if (sector == 3267) {
      axios.get(`/api/cm-yuva/franchise-sector`)
        .then(res => {
          setIndustries(res?.data?.sector);
        })
        .catch(err => console.log(err))
    } else if (sector) {
      axios.get(`/api/cm-yuva/get-sub-sub-categories/${sector}`)
        .then(res => {
          setIndustries(res?.data?.projectIndustry);
        })
        .catch(err => console.log(err))

    }
  }, [sector]);



  const enqHandlePaginateChange = (e) => {
    const value = e.target.value === "All" ? supplierProducts?.supplierProducts?.total : parseInt(e.target.value);
    setPaginate(value);
    setPage(1);
  };

  useEffect(() => {
    dispatch(fetchSubCategories(5));
  }, [dispatch]);

  useEffect(() => {
    const activeSupplier = supplier;

    const timer = setTimeout(() => {
      dispatch(fetchSupplierProductList(activeSupplier, page, search, sector, industry, paginate));
    }, 300);

    return () => clearTimeout(timer);

  }, [dispatch, page, supplier, sector, industry, search, paginate]);



  return (
    <div className="common-section  pt-2">
      <div className="container">

        <div className="section-head section-head-between filter-container">
          <div className="filter-search">
            <div className="search-form-control">
              <BiSearch className="search-form-control-icon" />
              <input
                type="text"
                className="form-control"
                placeholder="Search Machinery & Equipments"
                onChange={(e) => setSearch(e.currentTarget.value)}
              />
            </div>
          </div>
          <div className="filter-input">
            <select
              className="form-control form-select w-100"
              onChange={(e) => setSector(e.target.value)}
            >
              <option value="">Sector</option>
              {subcategory.map((item) => (
                <option value={item?.id} key={item.id}>
                  {item?.name}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-input">
            <select
              className="form-control form-select w-100"
              onChange={(e) => setIndustry(e.target.value)}
            >
              <option value="">Industry</option>
              {industries?.map((item) => (
                <option value={item?.id} key={item.id}>
                  {item?.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="row">
          <div className="d-flex justify-content-between">
          </div>
        </div>
        <div className="row">
          {(supplierProducts?.supplierProducts?.data.length > 0) ?
            supplierProducts?.supplierProducts?.data?.map((items) => (
              <Card
                key={items.id}
                items={items}
              />
            )
            ) : <div className="text-center">No Products Found</div>}

        </div>
        <div className="row">
          <div className="pagination-container d-flex justify-content-center mt-4">
            <div className="mt-3 d-lg-flex align-items-center text-center pb-1">
              <div className="d-inline-block me-3">
                <label className="me-1">Display:</label>
                <select className="form-select d-inline-block w-auto" onChange={enqHandlePaginateChange}>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <span className="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(supplierProducts?.supplierProducts?.total / paginate)}</strong> </span>
              <RoundedPagination currentPage={page} totalPages={Math.ceil(supplierProducts?.supplierProducts?.total / paginate)} onPageChange={(pageNumber) => setPage(pageNumber)} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierProductCards;